import moment from "moment";
import { Component } from "vue-property-decorator";
import { AbsenceSalarieV2Dto } from "../../../dto/GenApi.iNotPaie.Dto/AbsenceSalarieV2Dto";
import { ActionAbsencesEnum } from "../../../dto/GenApi.iNotPaie.Dto/ActionAbsencesEnum";
import { CommandeChangementEtatAbsenceDto } from "../../../dto/GenApi.iNotPaie.Dto/CommandeChangementEtatAbsenceDto";
import { EtatAbsencesEnum } from "../../../dto/GenApi.iNotPaie.Dto/EtatAbsencesEnum";
import { TypeCongeCompteurEnum } from "../../../dto/GenApi.iNotPaie.Dto/TypeCongeCompteurEnum";
import { getDureeAbsence, getLibelleAbsence } from "../../../Helper/absencePlanningHelper";
import dateHelper from "../../../Helper/dateHelper";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { EventBus } from "../../Controls/EventBus";
import EventConstants from "../../Controls/EventConstants";
import { ParametresInstance } from "../../Controls/Parameters";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { VueBase } from "../../Controls/VueBase";
import { ModalAlerteOptions } from "../../modalComponents/modalAlerte/modalAlerte";
import { AbsenceDisplay, EnumSortType } from "../listeConge/listeConge";
import { IListFilters, IListFiltersBack } from "./filterAbsences/filterAbsences";

interface ISelectPeriode {
    label: string,
    value: string
}

@Component({
    components: {
        CarteConge: require("../carteConge/carteConge.vue.html"),
        ListeConge: require("../listeConge/listeConge.vue.html"),
        FilterAbsences: require("./filterAbsences/filterAbsences.vue.html"),
        ModalAjoutConge: require("../modalAjoutConge/modalAjoutConge.vue.html")
    }
})
export default class DashboardCongeComponent extends VueBase {
    public typeConges = TypeCongeCompteurEnum;
    public initialExercice: Date | undefined = undefined;
    public exercice: Date | undefined = undefined;
    public moisRaz: number | undefined = undefined;
    public dataReady = false;
    public listLoad = true;
    public selectedPeriod: string | null = null;
    public listPeriods: ISelectPeriode[] = [];
    public listAbsences: AbsenceSalarieV2Dto[] = [];
    public listFilters: IListFilters = {
        statut: [],
        dateDebut: moment().startOf("day").toDate(),
        dateFin: null,
        type: []
    };

    public absenceToModifyId: number | null = null;
    public modalAbsenceVisible: boolean = false;

    public activated(): void {
        this.setExercice();
    }

    public mounted(): void {
        EventBus.$on(EventConstants.SOCIETE_CHANGED, this.setExercice);
        EventBus.$on(EventConstants.UPDATE_CONGES, this.setAbsences);
        this.setExercice();
        this.setAbsences();
    }

    public unmounted(): void {
        EventBus.$off(EventConstants.SOCIETE_CHANGED, this.setExercice);
    }

    private setExercice(): void {
        this.dataReady = false;
        this.exercice = moment.utc(ParametresInstance?.societeCourante?.DernierExercice).toDate();
        this.initialExercice = moment.utc(ParametresInstance?.societeCourante?.DernierExercice).toDate();
        this.moisRaz = ParametresInstance?.societeCourante?.MoisRaz;

        this.setOptionsSelect();
    }

    public openModalAbsence(absenceToModifyId: number): void {
        this.absenceToModifyId = this.listAbsences.find((absence) => absence.Id == absenceToModifyId)?.Id ?? null;

        this.modalAbsenceVisible = true;
    }

    /**
     * Ouvre une modale de confirmation avant d'annuler une demande d'absence
     * @param absence
     */
    public cancelAbsence(absence: AbsenceDisplay): void {
        this.absenceToModifyId = null;
        const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
            title: "Annulation demande d'absence",
            message: "Êtes-vous sûr de vouloir annuler votre demande d'absence ?",
            yesText: "Annuler ma demande",
            noText: "Annuler",
            callBackYes: () => {
                this.changerEtatAbsence(absence, ActionAbsencesEnum.DemanderAnnulerAbsenceParSalarie);
            },
            callBackNo: () => { }
        });

        EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
    }

    /**
     * Ouvre une modale de confirmation avant de supprimer une demande d'annulation
     * @param absence
     */
    public deleteCancellationAbsence(absence: AbsenceDisplay): void {
        this.absenceToModifyId = null;
        const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
            title: "Suppression demande d'annulation",
            message: "Êtes-vous sûr de vouloir supprimer votre demande d'annulation ?",
            yesText: "Supprimer l'annulation",
            noText: "Annuler",
            callBackYes: () => {
                this.changerEtatAbsence(absence, ActionAbsencesEnum.AnnulerDemandeAnnulationAbsenceParSalarie);
            },
            callBackNo: () => { }
        });

        EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
    }

    /**
     * Change l'état de l'absence (demande d'annulation par le salarié)
     * @param absence
     */
    private changerEtatAbsence(absence: AbsenceDisplay, action: ActionAbsencesEnum): void {
        const commande: CommandeChangementEtatAbsenceDto = { IdAbsence: absence.id, Action: action, Etat: absence.statut };
        ServicesFactoryInstance.AbsencesService.changerEtatAbsenceV2(commande, true, (data: AbsenceSalarieV2Dto[]) => {
            // Update the list with all returned absences
            data.forEach(updatedAbsence => {
                this.listAbsences = this.listAbsences.map((a) => a.Id === updatedAbsence.Id ? updatedAbsence : a);
            });

            // On affiche un message différent si l'absence a été annulée ou si c'est une demande d'annulation
            const newAbsence = this.listAbsences.find((elt) => elt.Id === data[0]?.Id);
            let message = "Votre demande d'annulation a bien été prise en compte";
            if (newAbsence?.Etat === EtatAbsencesEnum.Annule) {
                message = "Votre demande a bien été annulée";
            }

            NotificationServiceInstance.SendSuccess(message);
            EventBus.$emit(EventConstants.UPDATE_CONGES);
        }, () => {
            NotificationServiceInstance.SendFailed("L'annulation de l'absence n'a pas pu être effectuée.");
        });
    }

    public changePeriod(): void {
        if (this.selectedPeriod) {
            this.exercice = moment.utc(this.selectedPeriod).toDate();
        }
    }

    /**
     * Initialise la liste des périodes disponibles pour la sélection dans le tableau de bord des congés.
     * - Le premier élément correspond à la période en cours (Aujourd'hui) (début du mois de l'exercice sélectionné).
     * - Le deuxième élément correspond au mois de l'exercice sélectionné, mais la valeur pointe sur le début du mois suivant (exercice clôturé).
     * - Les éléments suivants représentent les mois suivants, chacun avec un label formaté et une valeur correspondant au début du mois suivant.
     * Met à jour la propriété `listPeriods` et sélectionne la période courante.
    */
    private setOptionsSelect(): void {
        if (this.exercice != null) {
            const baseMoment = moment.utc(this.exercice).set({ date: 1, hour: 12, minute: 0, second: 0, millisecond: 0 });

            // 1er item : label = Aujourd'hui (avant Période en cours) (1er du mois M), value = 1er du mois M => exercice non cloturé
            const labelM = baseMoment.format("MMMM YYYY");
            const labelMCap = labelM.charAt(0).toUpperCase() + labelM.slice(1);
            this.selectedPeriod = baseMoment.toISOString();
            this.listPeriods = [{
                label: "Aujourd'hui",
                value: this.selectedPeriod
            }];

            // 2e item : label = mois M, value = 1er du mois M+1 => exercice cloturé
            const moisPlus1 = baseMoment.clone().add(1, "months");
            this.listPeriods.push({
                label: labelMCap,
                value: moisPlus1.toISOString()
            });

            // Suivants : label = mois M+1, value = 1er du mois M+2, etc. => exercice cloturé
            for (let i = 1; i < 12; i++) {
                const labelMoment = baseMoment.clone().add(i, "months");
                const valueMoment = baseMoment.clone().add(i + 1, "months");
                const label = labelMoment.format("MMMM YYYY");
                const labelCap = label.charAt(0).toUpperCase() + label.slice(1);
                this.listPeriods.push({
                    label: labelCap,
                    value: valueMoment.toISOString()
                });
            }

            this.dataReady = true;
        }
    }

    /**
     * Met à jour les filtres de la liste des absences.
     * @param listFilter
     */
    public filterChanged(listFilter: IListFilters): void {
        this.listFilters = listFilter;

        this.setAbsences();
    }

    /**
     * Récupère la liste des absences à afficher dans le tableau
     */
    private setAbsences(): void {
        this.listLoad = true;

        const formatedListFilters: IListFiltersBack = {
            statut: this.listFilters.statut,
            type: this.listFilters.type,
            dateDebut: this.listFilters.dateDebut ? moment(this.listFilters.dateDebut).format("YYYY-MM-DDTHH:mm:ss") : null,
            dateFin: this.listFilters.dateFin ? moment(this.listFilters.dateFin).format("YYYY-MM-DDTHH:mm:ss") : null
        };

        ServicesFactoryInstance.AbsencesService.getAbsencesSalarieConnecteV2(formatedListFilters, (data) => {
            this.listAbsences = data;
            this.listLoad = false;
        }, () => {
            this.listLoad = false;
            NotificationServiceInstance.SendFailed("Une erreur est survenue lors de la récupération des absences.");
        });
    }

    /**
     * Computed property qui retourne la liste des absences filtrées selon les critères sélectionnés.
     */
    public get listAbsencesFiltered(): AbsenceDisplay[] {
        return this.listAbsences.map((absence) => ({
            id: absence.Id!,
            codeType: absence.CodeTypeAbsence ?? "",
            [EnumSortType.TYPE]: getLibelleAbsence(absence.LibelleTypeAbsence, absence.PoseeParGestionnaire),
            [EnumSortType.DATE_DEBUT]: dateHelper.formatDate(absence.DateDebut),
            [EnumSortType.DATE_FIN]: dateHelper.formatDate(absence.DateFin),
            [EnumSortType.DUREE]: getDureeAbsence(absence.NombreJours, absence.NombreHeures),
            [EnumSortType.STATUT]: absence.Etat,
            listeNiveauValideurs: absence.ListeNiveauValideurs,
            poseeParGestionnaire: absence.PoseeParGestionnaire,
            couleur: absence.Couleur ?? ""
        }));
    }
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsencesV2/dashboardConge/dashboardConge.ts